"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Minio;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _stream = require("stream");
const _minio = require("minio");
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _requestfilteringagent = require("request-filtering-agent");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Minio = class Minio {
    normalizeInput(input) {
        let endPoint = input.endPoint;
        let useSSL = input.useSSL;
        if (endPoint.startsWith('http://')) {
            endPoint = endPoint.replace('http://', '');
            useSSL = false;
        } else if (endPoint.startsWith('https://')) {
            useSSL = true;
            endPoint = endPoint.replace('https://', '');
        }
        endPoint = endPoint.trim().replace(/\/+$/, '');
        return _extends({}, input, {
            endPoint,
            useSSL
        });
    }
    async init() {
        const minioOptions = {
            port: +this.input.port || 9000,
            endPoint: this.input.endPoint,
            useSSL: this.input.useSSL === true,
            accessKey: this.input.access_key,
            secretKey: this.input.access_secret
        };
        this.minioClient = new _minio.Client(minioOptions);
        if (this.input.useSSL && this.input.ca) {
            this.minioClient.setRequestOptions({
                ca: this.input.ca
            });
        }
    }
    async test() {
        try {
            const stream = new _stream.Readable({
                read () {
                    this.push('Hello from Minio, NocoDB');
                    this.push(null);
                }
            });
            await this.fileCreateByStream('nc-test-file.txt', stream);
            return true;
        } catch (e) {
            _ncError.NcError._.pluginTestError(e == null ? void 0 : e.message);
        }
    }
    async fileRead(key) {
        try {
            const data = await this.minioClient.getObject(this.input.bucket, key);
            return await new Promise((resolve, reject)=>{
                const chunks = [];
                data.on('data', (chunk)=>{
                    chunks.push(chunk);
                });
                data.on('end', ()=>{
                    const buffer = Buffer.concat(chunks);
                    resolve(buffer);
                });
                data.on('error', (err)=>{
                    reject(err);
                });
            });
        } catch (error) {
            _ncError.NcError._.storageFileReadError(error == null ? void 0 : error.message);
        }
    }
    async fileCreate(key, file) {
        try {
            const fileStream = _fs.default.createReadStream(file.path);
            return await this.fileCreateByStream(key, fileStream, {
                mimetype: file == null ? void 0 : file.mimetype
            });
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(error == null ? void 0 : error.message);
        }
    }
    async fileCreateByStream(key, stream, options) {
        try {
            const streamError = new Promise((_, reject)=>{
                stream.on('error', (err)=>{
                    reject(err);
                });
            });
            // Create a transform stream to ensure data is in Buffer format
            const bufferStream = new _stream.Readable({
                read () {}
            });
            stream.on('data', (chunk)=>{
                // Convert string chunks to Buffer if necessary
                if (typeof chunk === 'string') {
                    bufferStream.push(Buffer.from(chunk, 'utf8'));
                } else {
                    bufferStream.push(chunk);
                }
            });
            stream.on('end', ()=>{
                bufferStream.push(null);
            });
            stream.on('error', (err)=>{
                bufferStream.emit('error', err);
            });
            const uploadParams = {
                Key: key,
                Body: bufferStream,
                metaData: {
                    ContentType: options == null ? void 0 : options.mimetype,
                    size: options == null ? void 0 : options.size
                }
            };
            const upload = this.upload(uploadParams);
            return await Promise.race([
                upload,
                streamError
            ]);
        } catch (error) {
            _ncError.NcError._.storageFileStreamError(error == null ? void 0 : error.message);
        }
    }
    async fileCreateByUrl(key, url, { fetchOptions: { buffer } = {
        buffer: false
    } }) {
        try {
            const response = await _axios.default.get(url, {
                httpAgent: (0, _requestfilteringagent.useAgent)(url),
                httpsAgent: (0, _requestfilteringagent.useAgent)(url),
                responseType: buffer ? 'arraybuffer' : 'stream'
            });
            const uploadParams = {
                ACL: 'public-read',
                Key: key,
                Body: response.data,
                metaData: {
                    ContentType: response.headers['content-type']
                }
            };
            const responseUrl = await this.upload(uploadParams);
            return {
                url: responseUrl,
                data: response.data
            };
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(`Failed to create file from URL: ${error == null ? void 0 : error.message}`);
        }
    }
    async upload(uploadParams) {
        try {
            await this.minioClient.putObject(this.input.bucket, uploadParams.Key, uploadParams.Body, uploadParams.metaData);
            if (this.input.useSSL && this.input.port === 443) {
                return `https://${this.input.endPoint}/${uploadParams.Key}`;
            } else if (!this.input.useSSL && this.input.port === 80) {
                return `http://${this.input.endPoint}/${uploadParams.Key}`;
            } else {
                return `http${this.input.useSSL ? 's' : ''}://${this.input.endPoint}:${this.input.port}/${uploadParams.Key}`;
            }
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(error == null ? void 0 : error.message);
        }
    }
    async getSignedUrl(key, expiresInSeconds = 7200, pathParameters) {
        try {
            if (key.startsWith(`${this.input.bucket}/nc/uploads`) || key.startsWith(`${this.input.bucket}/nc/thumbnails`)) {
                key = key.replace(`${this.input.bucket}/`, '');
            }
            return this.minioClient.presignedGetObject(this.input.bucket, key, expiresInSeconds, pathParameters);
        } catch (error) {
            _ncError.NcError._.storageFileReadError(`Failed to generate signed URL: ${error == null ? void 0 : error.message}`);
        }
    }
    // TODO - implement
    fileReadByStream(_key) {
        return Promise.resolve(undefined);
    }
    // TODO - implement
    getDirectoryList(_path) {
        return Promise.resolve(undefined);
    }
    async fileDelete(path) {
        try {
            await this.minioClient.removeObject(this.input.bucket, path);
            return true;
        } catch (error) {
            _ncError.NcError._.storageFileDeleteError(error == null ? void 0 : error.message);
        }
    }
    async scanFiles(globPattern) {
        // Remove all dots from the glob pattern
        globPattern = globPattern.replace(/\./g, '');
        // Remove the leading slash
        globPattern = globPattern.replace(/^\//, '');
        // Make sure pattern starts with nc/uploads/
        if (!globPattern.startsWith('nc/uploads/')) {
            globPattern = `nc/uploads/${globPattern}`;
        }
        // Minio does not support glob so remove *
        globPattern = globPattern.replace(/\*/g, '');
        const stream = new _stream.Readable({
            read () {}
        });
        stream.setEncoding('utf8');
        const listObjects = async ()=>{
            const objectStream = this.minioClient.listObjectsV2(this.input.bucket, globPattern, true);
            for await (const item of objectStream){
                stream.push(item.name);
            }
            stream.push(null);
        };
        listObjects().catch((error)=>{
            stream.destroy(error);
        });
        return stream;
    }
    getUploadedPath(path) {
        const protocol = this.input.useSSL ? 'https' : 'http';
        const defaultPort = this.input.useSSL ? 443 : 80;
        const cleanPath = path.startsWith('/') ? path.slice(1) : path;
        let url;
        if (this.input.port === defaultPort) {
            url = `${protocol}://${this.input.endPoint}/${cleanPath}`;
        } else {
            url = `${protocol}://${this.input.endPoint}:${this.input.port}/${cleanPath}`;
        }
        return {
            path,
            url
        };
    }
    constructor(input){
        this.name = 'Minio';
        this.input = this.normalizeInput(input);
    }
};
